<!-- 
  time:2024/01/03
  component：列表中排序
  
  此时供多级表头的排序使用，需要与headerRender配合使用
  单级表头无需使用该组件直接声明sortable=true即可
  sortText:排序文字
  sortName:排序字段
  sortBy:排序列表（必传）

  回调：
  ascending(sortArray)：升序
  cancelAscending(sortArray)：取消升序
  descending(sortArray)：降序
  cancelDescending(sortArray)：取消降序
-->
<template>
  <div class="tableSort pointer">
    <span @click='clickSort'>{{sortText}}</span>
    <i ref="ascending" class="tableSort-top" @click="ascending"></i>
    <i ref="descending" class="tableSort-bottom" @click="descending"></i>
  </div>
</template>

<script>
export default {
  props:{
    sortText:{
      type: String,
      default: ''
    },
    sortName:{
      type: String,
      default: ''
    },
    sortBy:{
      default(){
        return [];
      }
    },
  },
  data(){
    return {
      ascendingType:false,
      descendingType:false,
      sortArray:[],
      sortType:2, //0:升序1：降序2：无排序
    }
  },
  methods:{
    ascending(){  //升序
      this.$refs['descending'].style.borderTopColor = '#C0C4CC'
      if (this.ascendingType) {
        this.ascendingType = false
        this.$refs['ascending'].style.borderBottomColor = '#C0C4CC'
        let sortIndex = null
        this.sortArray.map((item,index) => {
          if (item.fieldName === this.sortName) {
            sortIndex = index
          }
        })
        this.sortArray.splice(sortIndex,1)
        this.sortType = 2
        this.$emit('cancelAscending',this.sortArray)
        return
      }
      this.ascendingType = true
      this.descendingType = false
      this.$refs['ascending'].style.borderBottomColor = '#cd0100'
      let sortIndex = null
      this.sortArray.map((item,index) => {
        if (item.fieldName === this.sortName) {
          sortIndex = index
        }
      })
      if (sortIndex != null) {
        this.sortArray.splice(sortIndex,1)
      }
      this.sortArray.push({
        'fieldName':this.sortName,
        'orderByType':0
      })
      this.sortType = 0
      this.$emit('ascending',this.sortArray)
    },
    descending(){  //降序
      this.$refs['ascending'].style.borderBottomColor = '#C0C4CC'
      if (this.descendingType) {
        this.descendingType = false
        this.$refs['descending'].style.borderTopColor = '#C0C4CC'
        let sortIndex = null
        this.sortArray.map((item,index) => {
          if (item.fieldName === this.sortName) {
            sortIndex = index
          }
        })
        this.sortArray.splice(sortIndex,1)
        this.sortType = 2
        this.$emit('cancelDescending',this.sortArray)
        return
      }
      this.descendingType = true
      this.ascendingType = false
      this.$refs['descending'].style.borderTopColor = "#cd0100"
      let sortIndex = null
      this.sortArray.map((item,index) => {
        if (item.fieldName === this.sortName) {
          sortIndex = index
        }
      })
      if (sortIndex != null) {
        this.sortArray.splice(sortIndex,1)
      }
      this.sortArray.push({
        'fieldName':this.sortName,
        'orderByType':1
      })
      this.sortType = 1
      this.$emit('descending',this.sortArray)
    },
    noSort(){ //无排序
      this.$refs['ascending'].style.borderBottomColor = '#C0C4CC'
      this.$refs['descending'].style.borderTopColor = '#C0C4CC'
      let sortIndex = null
      this.sortArray.map((item,index) => {
        if (item.fieldName === this.sortName) {
          sortIndex = index
        }
      })
      this.sortArray.splice(sortIndex,1)
    },
    clickSort(){  //自动排序
      if (this.sortType === 2) {
        this.sortType = 0
        this.ascending()
      }else if(this.sortType === 0){
        this.sortType = 1
        this.descending()
      }else if(this.sortType === 1){
        this.sortType = 2
        this.noSort()
      }
    },
  },
  created(){
    this.sortArray = this.sortBy
  },
}
</script>

<style lang='scss'>
.tableSort{
  text-align: left;
  i {
    position: absolute;
    font-size: 14px;
    line-height: 8px;
    height: 0px;
    width: 0px;
    margin-left: 3px;
  }
  &-top{
    color:#C0C4CC;
    border: solid 5px transparent;
    border-bottom-color: #C0C4CC;
    margin-top: -3px;
  }
  &-bottom{
    color:#C0C4CC;
    border: solid 5px transparent;
    border-top-color: #C0C4CC;
    margin-top: 9px;
  }
}
</style>